import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import { PreWrapSpan } from './styles';
import { Mandatory } from '90.quickConnect.Models/enums';
import { FlexRow } from '50.quickConnect.Fields/styles';

const useLabelForSummaryItem = (
  label: string,
  mandatory: Mandatory | undefined,
  parentName: string,
  errors: string[] | undefined,
): JSX.Element => {
  const { t } = useTranslation('declaration');

  const [labelClass, setLabelClass] = useState('');

  const theme = useTheme();
  const labelSpan = useMemo(() => {
    let mandatoryIndicator: JSX.Element | undefined = undefined;
    if (mandatory === Mandatory.Required || mandatory === Mandatory.ChildsValue) {
      if (errors && errors.length > 0) {
        mandatoryIndicator = (
          <span style={{ color: theme.palette.error.main, fontWeight: 'bolder', marginRight: '0.5em' }}>*</span>
        );
      } else {
        mandatoryIndicator = <span style={{ marginRight: '0.5em' }}>* </span>;
      }
    }
    return (
      <Box>
        <Box className={labelClass} sx={{ ...FlexRow, alignItems: 'flex-start' }}>
          {mandatoryIndicator}
          <PreWrapSpan data-cy={`${parentName}-label`} dangerouslySetInnerHTML={{ __html: label }}></PreWrapSpan>
        </Box>
        {errors &&
          errors.map((error, index) => (
            <Typography key={index} variant="body2" color="error">
              {error !== t('errors_mandatory_field') && error}
            </Typography>
          ))}
      </Box>
    );
  }, [label, mandatory, labelClass, parentName, errors, theme.palette.error.main, t]);

  useEffect(() => {
    if (errors && errors.length > 0) {
      setLabelClass('animate__animated animate__pulse');
    } else {
      setLabelClass('');
    }
  }, [errors]);

  return labelSpan;
};

export default useLabelForSummaryItem;
